<template>
    <div class="content-wrapper flex flex-direction flex-sub padding-sm">
        <div class="bg-white padding-sm flex-sub">
            <div class="search-container flex align-center justify-between">
                <div class="flex align-center ">
                    <el-input v-model="searchName" placeholder="请输入关键字"/>
                    <el-button
                        class="btn mid margin-left-xs"
                        type="primary"
                        @click="search"><i class="el-icon-search"></i>搜索
                    </el-button>
                </div>
                <div class="flex align-center">
                    <el-button
                        class="margin-left btn mid"
                        type="primary"
                        @click="toPage(`/digitize`)">预览
                    </el-button>
                </div>
            </div>
            <div class="page-list flex flex-direction margin-top-sm">
                <el-table
                    v-loading="loading"
                    :data="lists"
                    border
                    header-row-class-name="table-header"
                    style="width: 100%">
                    <el-table-column label="序号" prop="index" width="80">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ (scope.$index + 1) + (page - 1) * limit }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="标题" prop="title">
                        <template slot-scope="scope">
                            <div class="table-item">
                                {{ scope.row.title }}
                            </div>
                        </template>
                    </el-table-column>
<!--                    <el-table-column label="状态" prop="title">-->
<!--                        <template slot-scope="scope">-->
<!--                            <div class="table-item">-->
<!--                                {{ scope.row.is_true === 1 ? '未发布' : '已发布' }}-->
<!--                            </div>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
                    <el-table-column fixed="right" label="操作" prop="end_time" width="220">
                        <template slot-scope="scope">
                            <div class="table-item text-sm">
                                <el-button type="text" @click="showItem(scope.row.id)">查看</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    :current-page.sync="page"
                    :page-size="limit"
                    :total="total"
                    background
                    class="page-all margin-top self-end"
                    layout="prev, pager, next,total"
                    @current-change="getList">
                </el-pagination>
            </div>
        </div>
        <flow-detail-dialog :aid="cur_aid" :dialog-visible="flowDetailDialog"  @watchState="watchState"></flow-detail-dialog>
    </div>
</template>

<script>
import {zhDate} from "@/utils/utils";
import {backActiveList} from "@/api";
import FlowDetailDialog from "@/views/web/components/FlowDetailDialog";

export default {
    name: "flow-list",
    components: {FlowDetailDialog},
    data() {
        return {
            searchName: '',
            lists: [],
            page: 1,
            limit: 10,
            total: 0,
            loading: false,
            cur_aid: 0,
            flowDetailDialog: false,
        };
    },
    props: {},
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.init()
    },
    activated() {
        this.init()
    },
    methods: {
        init() {
            this.$emit('setIndex', [5, 1])
            this.getList()
        },
        async getList() {
            this.loading = true
            let _data = await backActiveList(this.searchName, this.page, this.limit)
            this.lists = _data.data.data
            this.total = _data.data.total
            this.loading = false
        },
        search() {
            this.page = 1
            this.getList()
        },
        showItem(item) {
            this.cur_aid = item
            this.flowDetailDialog = true
        },
        watchState() {
            this.cur_aid = 0;
            this.flowDetailDialog = false
        },
        toPage(path) {
            this.$router.push(path)
        },
    },
    filters: {
        zhDate(val) {
            return zhDate(val, 2)
        },
    },
}
</script>

<style lang="scss" scoped>
.content-wrapper {

    .search-item {
        margin-bottom: 20px;
    }

    .search-tip {
        width: 120px;
        text-align: right;
    }

}
</style>